import { request } from "../../apis";
import { getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency()

export const apiGetInboxCounter = (params) =>
  request("get", `/${userCurrency}/inbox/counter`, params, true);

export const apiGetMessageList = (params) =>
  request("get", `/${userCurrency}/inbox`, params, true);

export const apiUpdateMessageReadStatus = (messageId, params) =>
  request("put", `/${userCurrency}/inbox/${messageId}`, params, true);

export const apiReadAllMessage = (params) =>
request("put", `/${userCurrency}/inboxes`, params, true);

export const apiGetAnnouncementList = (params) =>
  request("get", `/${userCurrency}/notice`, params, true);
